import { render, staticRenderFns } from "./RegionBase.vue?vue&type=template&id=4116842e&lang=pug&"
import script from "./RegionBase.vue?vue&type=script&lang=js&"
export * from "./RegionBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports